import React from 'react';

import Format from "core/gd/utils/format";

export default class TimeSelectorOption extends React.Component {

    onClick = (e) => {
        e.stopPropagation();
        this.props.onClick(this.props.value);
    }

    renderDiffValue = () => {
        if (this.props.diffValue) {
            const diff = this.props.value.diff(this.props.diffValue, 'minutes');
            const diffLabel = gd.utils.humanTimeShort(diff, gd.utils.TYPE_MINUTES, {
                minuteLabel:    'min',
                minutesLabel:   'min',
                hourLabel:      'hr',
                hoursLabel:     'hrs'
            });
            return <span className="diff-label"> ({diffLabel})</span>
        }

        return null
    }

    render() {
        const label = Format.timeUserFormat(this.props.value);

        return (
            <div className={Classes("option", {'selected': this.props.isSelected})} onClick={this.onClick}>
                <div className="label">{label}{this.renderDiffValue()}</div>
            </div>
        );
    }
}